import { get, put } from "../../utils/httpClient";

const boardPermissionRequestService = () => {
  const prefixApi = "duedates/boardpermissionrequest";

  const getQualifyingBoards = async () => {
    return await get(`/${prefixApi}/boards`);
  };

  const hasPendingPermissions = async () => {
    return await get(`/${prefixApi}/has-pending`);
  };

  const userHasPendingPermissions = async () => {
    return await get(`/${prefixApi}/user-has-pending`);
  };

  const approveRequest = async (requestId) => {
    return await put(`/${prefixApi}/${requestId}/approve`);
  };

  const denyRequest = async (requestId) => {
    return await put(`/${prefixApi}/${requestId}/deny`);
  };

  const approveManyRequest = async (requestIds) => {
    return await put(`/${prefixApi}/approve-many`, { requestIds });
  };

  const denyManyRequest = async (requestIds) => {
    return await put(`/${prefixApi}/deny-many`, { requestIds });
  };

  const approveAllRequest = async () => {
    return await put(`/${prefixApi}/approve-all`);
  };

  const denyAllRequest = async () => {
    return await put(`/${prefixApi}/deny-all`);
  };

  return {
    hasPendingPermissions,
    userHasPendingPermissions,
    approveRequest,
    denyRequest,
    getQualifyingBoards,
    approveManyRequest,
    denyManyRequest,
    approveAllRequest,
    denyAllRequest,
  };
};

export default boardPermissionRequestService;
